<template>
  <div class="hosting-container">
    <div>
      <div class="maps-content">
        <Suspense>
          <template #default>
            <div v-if="isoCode === 'ES' && showBookingMap">
              <ins
                id="booking"
                class="bookingaff"
                data-aid="2298775"
                data-target_aid="2298775"
                data-prod="map"
                data-width="auto"
                :data-height="windowWidth < 768 ? 280 : 380"
                data-lang="ualng"
                data-dest_id="0"
                data-dest_type="landmark"
                :data-latitude="location.latitude"
                :data-longitude="location.longitude"
                :data-landmark_name="address"
                :data-checkin="formattedStartDate"
                data-mwhsb="1"
                :data-address="address"
              >
                <a id="noBooking" href="//www.booking.com?aid=2298775">
                  Booking.com
                </a>
              </ins>
            </div>
            <iframe
              v-else-if="acommodationURL"
              id="stay22-widget"
              loading="lazy"
              aria-hidden="true"
              :src="acommodationURL"
              frameborder="noborder"
              title="Stay22"
              width="100%"
              :height="windowWidth < 768 ? '220' : '380'"
            />
          </template>
        </Suspense>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, toRefs, ref, onMounted } from "vue";

const props = defineProps({
  location: {
    type: Object,
    default: () => {}
  },
  isoCode: {
    type: String,
    default: () => {}
  },
  address: {
    type: String,
    default: () => {}
  },
  accommodation: {
    type: Object,
    default: () => {}
  },
  startDate: {
    type: String,
    default: undefined
  },
  verticalAlign: {
    type: Boolean,
    default: false
  }
});

const { location, isoCode, address, accommodation, startDate } = toRefs(props);

const showBookingMap = ref(true);
const locationMap = ref({});
const acommodationURL = ref(undefined);
const windowWidth = ref(0);
windowWidth.value = window.innerWidth;
const emits = defineEmits(["hasAccommodation"]);

const calculateAcommodationUrl = () => {
  if (accommodation.value?.service === "airbnb")
    acommodationURL.value = accommodation.value?.url;

  if (location.value.latitude && location.value.longitude) {
    const stay22BaseUrl =
      "https://www.stay22.com/embed/gm?aid=wegow&maincolor=252525&backgroundColor=2EFFEC&markerimage=https://cdn.wegow.com/no-delete/images/wegow_logo_stay.png";
    acommodationURL.value = `${stay22BaseUrl}&lat=${location.value.latitude}&lng=${location.value.longitude}&checkin=${formattedStartDate.value}&address=${address.value}`;
  } else {
    acommodationURL.value = undefined;
  }
  emits("hasAccommodation", acommodationURL.value);
};

const formattedStartDate = computed(() => {
  const date = startDate.value;
  return (date ? new Date(date) : new Date()).toDateString();
});

const showBookingInit = () => {
  if (props.isoCode === "ES") {
    showBookingMap.value = true;
    bookingMap();
  } else {
    showBookingMap.value = false;
    calculateAcommodationUrl();
  }
};
onBeforeMount(() => {
  if (!location.value.latitude && !location.value.longitude) {
    locationMap.value = address.value;
  } else {
    locationMap.value = props.location;
    locationMap.value = {
      longitude: props.longitude,
      latitude: props.latitude
    };
  }
  showBookingInit();
});
onMounted(() => {
  let bookingImage = document.querySelectorAll("marker-bookingdc");
  if (bookingImage) {
    bookingImage.forEach(logo => {
      logo.alt = "Booking logo";
    });
  }
});
const bookingMap = () => {
  var s = document.createElement("script"),
    p = document.getElementsByTagName("script")[0];
  s.type = "text/javascript";
  s.async = true;
  s.dataCookieconsent = "marketing";
  s.src =
    "//cf.bstatic.com/static/affiliate_base/js/flexiproduct.js" +
    "?v=" +
    +new Date();
  s.defer = true;
  p.parentNode?.insertBefore(s, p);

  setTimeout(() => {
    if (document.getElementById("noBooking")) {
      showBookingMap.value = false;
      calculateAcommodationUrl();
    }
  }, 300);
};
</script>

<style lang="scss" scoped>
.affiliate_map_container {
  border: none;
}
.hosting-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.titles {
  margin-left: auto;
  margin-top: -4.5%;
  margin-bottom: 30px;
}

// .reserve-button {
//   background-color: #2effec;
//   color: black;
//   border-radius: 20px;
//   font-size: 16px;
//   border: none;
//   cursor: pointer;
//   transition: background-color 0.3s ease, transform 0.2s ease;
//   margin-right: 10px; /* Espacio entre el botón y un posible título */
//   padding: 5px 30px;
// }
.maps-content {
  width: 100%;
  min-height: 100%;
}
</style>
